import {api} from "./index";
import {AuthRequest} from "../../shared/types/auth-request";
import {HttpStatusCode} from "axios";
import {Teacher} from "../../shared/types/teacher";

export const loginFetch = async (authRequest: AuthRequest) => {
    return (
        await api.post(
            `/auth/login`,
            authRequest
        )
    ).status === HttpStatusCode.NoContent;
};

export const logoutFetch = async () => {
    return (
        await api.post(
            `/auth/logout`
        )
    ).status === HttpStatusCode.NoContent;
};